import useChainFlow from 'core/guestBooking/useChainFlow';
import { loadGuardingRequestForm, updateGuardingRequestForm } from './guardingRequestFormApi';

/**
 * The guarding chain's step flow, serving both an authenticated request and a
 * guest (booking-link) one. See useChainFlow.
 */
const useGuardingFlow = () => useChainFlow({
    basePath: 'guarding-request',
    loadThunk: loadGuardingRequestForm,
    updateThunk: updateGuardingRequestForm,
    reviewStep: 4,
});

export default useGuardingFlow;
